<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <!-- 컨텐츠 row 시작 -->
    <div class="contents-row app-risk-level-wrapper">
      <!-- 적응형 (필독!! : row > bs-row-divide, col-xs, col-sm, col-md 한셋트로 구조를 맞춰야함 ) 시작 -->
      <div class="row">
        <!-- 위험도 부분 -->
        <div class="col-xs-7 col-sm-7 col-md-7">
          <div ref="chartArea"
               class="app-risk-level-chart"
          >
            <!-- 컨텐츠 높이 250px - padding 위 / 아래 24px -->
            <gauge-chart ref="chartInstance"
                         :data="widgetChartData"
                         :color="chartColor"
                         :min="0"
                         :max="5"
                         :titleFontSize="12"
                         :detailFontSize="32"
                         :title-options="{color: '#000000'}"
                         :titleOffset="['0%', '-20%']"
                         :detailOffset="['0%', '15%']"
                         :radius="'78%'"
                         :height="226"
                         :detailFormatter="() => this.riskValue.toFixed(1)"
            />
          </div>
        </div>

        <!-- 위험도 현황 테이블 부분 -->
        <div class="col-xs-5 col-sm-5 col-md-5">
          <div class="app-risk-level-group">
            <div class="contents-row app-risk-level-table-title">
              <!--TAMS-->
              {{ $t('dash.unitCaseN', { unit_time: this.unitTime }) }}
            </div>
            <table class="app-risk-level-table">
              <colgroup>
                <!--<col width="15%"/>-->
                <col width="50%"/>
                <col width="50%"/>
              </colgroup>
              <tbody>
              <!-- 위험도 높음 4이상 -->
              <tr>
                <!--<td class="td-arrow">-->
                <!--<span class="app-risk-level-arrow"-->
                <!--:style="riskAverage >= 4 ? '' : 'display: none'"-->
                <!--/>-->
                <!--</td>-->
                <td>
                  <span class="app-risk-level-box level-red"/>
                  <span>Very high</span>
                </td>
                <td class="td-value">
                  <span class="app-risk-level-value">{{ separateByComma(widgetData.level5) }}</span>
                </td>
              </tr>
              <!-- 위험도 높음 3부터 3.9 까지 -->
              <tr>
                <td>
                  <span class="app-risk-level-box level-orange"/>
                  <span>High</span>
                </td>
                <td class="td-value">
                  <span class="app-risk-level-value">{{ separateByComma(widgetData.level4) }}</span>
                </td>
              </tr>
              <!-- 위험도 보통 2부터 2.9 까지 -->
              <tr>
                <td>
                  <span class="app-risk-level-box level-yellow"/>
                  <span>Medium</span>
                </td>
                <td class="td-value">
                  <span class="app-risk-level-value">{{ separateByComma(widgetData.level3) }}</span>
                </td>
              </tr>
              <!-- 위험도 낮음 1부터 1.9 까지 -->
              <tr>
                <td>
                  <span class="app-risk-level-box level-green"/>
                  <span>Low</span>
                </td>
                <td class="td-value">
                  <span class="app-risk-level-value">{{ separateByComma(widgetData.level2) }}</span>
                </td>
              </tr>
              <!-- 위험도 매우 낮음 0부터 0.9 까지-->
              <tr>
                <td>
                  <span class="app-risk-level-box level-blue"/>
                  <span>Very low</span>
                </td>
                <td class="td-value">
                  <span class="app-risk-level-value">{{ separateByComma(widgetData.level1) }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Mixin 객체
import {widgetMixin} from '~/mixins/widgetCommonMixin'

// 스토어 헬퍼
import {createNamespacedHelpers} from 'vuex'

// 스토어 헬퍼 객체
const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

export default {
  name: 'widgetFwAppRisk',
  directives: {},
  mixins: [widgetMixin],
  data () {
    return {
      w: 2,
      self: this,
      title: 'widgetFwAppRisk',
      isLock: false,
      isMove: true,
      isResize: false,
      isMaximum: false,
      eventBus: true,
      deviceType: [20],
      widgetData: {
        level1: 0,
        level2: 0,
        level3: 0,
        level4: 0,
        level5: 0
      },
      widgetChartData: [],
      riskAverage: 0,
      chartInstance: null,
      chartColor: '#95d6ff',
      riskValue: 0,
      // TAMS
      unitTime: ''
    }
  },
  mounted () {
    this.chartInstance = this.$refs.chartInstance
  },
  beforeDestroy () {
    // 셀프 객체 초기화
    this.self = null
  },
  methods: {
    ...mapActions([
      'getWidgetData'
    ]),
    // 위젯 대상 장비 필터 설정.
    async onChangeWidgetMachId ({machId}) {
      // 위젯 옵션 변경 - 저장에 필요한 값???
      this.opts.mach_id = machId
      this.getWidgetContentsData(true, machId)
    },
    getWidgetLevel (riskCountData) {
      const level1 = riskCountData.filter(riskData => riskData.name === 1)
      const level2 = riskCountData.filter(riskData => riskData.name === 2)
      const level3 = riskCountData.filter(riskData => riskData.name === 3)
      const level4 = riskCountData.filter(riskData => riskData.name === 4)
      const level5 = riskCountData.filter(riskData => riskData.name === 5)

      this.widgetData.level1 = (level1.length > 0) ? level1[0].value || 0 : 0
      this.widgetData.level2 = (level2.length > 0) ? level2[0].value || 0 : 0
      this.widgetData.level3 = (level3.length > 0) ? level3[0].value || 0 : 0
      this.widgetData.level4 = (level4.length > 0) ? level4[0].value || 0 : 0
      this.widgetData.level5 = (level5.length > 0) ? level5[0].value || 0 : 0
    },
    getWidgetColor (riskLevelValue) {
      if (riskLevelValue >= 5) {
        this.chartColor = '#fc4132'
      } else if (riskLevelValue >= 4 && riskLevelValue < 5) {
        this.chartColor = '#ffa60a'
      } else if (riskLevelValue >= 3 && riskLevelValue < 4) {
        this.chartColor = '#f2d300'
      } else if (riskLevelValue >= 2 && riskLevelValue < 3) {
        this.chartColor = '#27c141'
      } else {
        this.chartColor = '#95d6ff'
      }
    },
    async getWidgetContentsData (init = false, extraParams = null) {
      const contentsOptions = {}

      // 장비 filter 추가
      if (this.opts.mach_id) contentsOptions.machId = this.opts.mach_id

      // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
      if (extraParams && extraParams.machId) contentsOptions.machId = extraParams.machId

      // Progress 출력 여부
      this.showProgress(true)

      // init Flag가 True라면 기존 데이터 초기화
      if (init) {
        // 위험도 레벨 초기화
        this.widgetData = {
          level1: 0,
          level2: 0,
          level3: 0,
          level4: 0,
          level5: 0
        }
        // 게이지 차트 데이터
        this.riskValue = 0
        this.widgetChartData = [{name: this.$t('dash.widgetFwAppRisk_label_riskAverage'), value: 0}]
        // 차트 초기화
        this.$refs.chartInstance.clear()
      }

      // API 호출 - 해당 화면은 2번의 API를 호출함
      const resRiskCount = await this.getWidgetData(_.assign({
        widgetType: 'app_risk_count'
      }, contentsOptions))

      const resRiskLevel = await this.getWidgetData(_.assign({
        widgetType: 'app_risk_avg'
      }, contentsOptions))

      // Series 데이터 구성 1
      if (resRiskCount.code === 'ok') {
        // 위험도별 카운트 개산
        const riskCountData = resRiskCount.result.result || []
        this.unitTime = resRiskCount.result.unit_time || '' // TAMS

        // 위험도별 카운트 정보가 있으면, widgetData에 맵핑
        if (riskCountData.length > 0) {
          this.getWidgetLevel(riskCountData)
        } else {
          // TAMS
          this.widgetData = {
            level1: 0,
            level2: 0,
            level3: 0,
            level4: 0,
            level5: 0
          }
        }
      }

      // Series 데이터 구성 2
      if (resRiskLevel.code === 'ok') {
        // 애플리케이션 위험도 데이터 구하기
        const riskLevelData = resRiskLevel.result.result || 0
        // 위험도 값 소숫점 1자리 계산
        const riskLevelValue = _.round(riskLevelData.value, 1) || 0

        // 위험도 소숫점 1차리에 따라 색상 변경
        this.getWidgetColor(riskLevelValue)
        // 위젯 데이터 / 옵션 수정
        this.riskValue = riskLevelValue
        const riskVal = riskLevelValue > 5 ? 5 : riskLevelValue
        this.widgetChartData = [{name: this.$t('dash.widgetFwAppRisk_label_riskAverage'), value: riskVal}]
      }
      // Progress 출력 여부
      this.showProgress(false)
    },

    // 설명: 게이지 차트의 리사이즈 작업을 수행한다. 높이는 고정이므로 업데이트하지 않는다.
    onResizeContentsFromWidget () {
      const chartArea = this.$refs.chartArea

      if (chartArea) {
        const wrapperWidget = chartArea.clientWidth
        const chartInstance = this.$refs.chartInstance

        // 위젯의 최대 높이는 250px로 고정되므로 따로 연산하지 않는다.
        chartInstance.setSize(wrapperWidget - 50, null)
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
tr {
  font-size: 12px;
  vertical-align: middle;
}

tr td span {
  vertical-align: middle;
}
</style>
